export const zones = [
  {
    name: 'Zone',
    url: '/base/zone',
    icon: 'fa fa-cube'
  },
  {
    name: 'Create Zone',
    url: '/base/zone/create',
    icon: 'icon-plus'
  }
];
